import { useTranslation } from 'react-i18next';
import { Ban } from 'lucide-react';

import type { LogoutProps } from './types';

import { Button } from '@/components/ui/button';

type BlacklistedScreenProps = {
  message?: string | null;
  logOutProps: LogoutProps;
};

export const BlacklistedScreen = (props: BlacklistedScreenProps) => {
  const { message, logOutProps } = props;
  const { t } = useTranslation();

  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center gap-6 p-6 text-center">
      <Ban className="text-destructive size-12" />
      {message ? (
        <p className="max-w-md text-lg font-medium">{message}</p>
      ) : null}
      <form
        method="post"
        action={logOutProps.url}
      >
        <input
          type="hidden"
          name="_method"
          value="delete"
        />
        <input
          type="hidden"
          name="authenticity_token"
          value={logOutProps.token}
        />
        <Button type="submit">{t('logOut')}</Button>
      </form>
    </div>
  );
};
